<template>
  <bottomAlert
    :show="show"
    @close="show = false"
    :class="{
      shareAlert: true,
      posterAlert: posterShowCondt,
      padBottom30: viewType == 3
    }"
    maskClose="true"
  >
    <div class="optBox" id="shareAlertBtns">
      <div @click="share('wechat1')" class="opt" v-if="!noShareWx">
        <img
          :src="
            isAlipayMiniUa
              ? require('../../assets/share/alimini.png')
              : require('../../assets/share/wx.png')
          "
        />
        <div class="text">{{ isAlipayMiniUa ? '支付宝' : '微信' }}</div>
      </div>
      <div
        @click="share('wechatn')"
        class="opt"
        v-if="
          (isHllApp || !isHllApp) &&
            !isWxMiniProgram &&
            !noShareWx &&
            !isAlipayMiniUa &&
            !isXlApp
        "
      >
        <img src="../../assets/share/pyq.png" />
        <div class="text">朋友圈</div>
      </div>
      <!-- <div
        @click="share('wechatn')"
        class="opt"
        v-if="
          (isIOS ||
            ((androindShare || (!isIOS && !posterShow && !androindShare)) &&
              isHllApp) ||
            !isHllApp) &&
            !isWxMiniProgram &&
            !noShareWx &&
            !isAlipayMiniUa
        "
      >
        <img src="../../assets/share/pyq.png" />
        <div class="text">朋友圈</div>
      </div> -->
      <template v-if="!isHideQrcode">
        <div class="opt" v-if="posterShowCondt" @click="saveImg">
          <img src="../../assets/share/share_ico4.png" />
          <div class="text">保存图片</div>
        </div>
        <div class="opt" v-else-if="sharePoster" @click="showPoster">
          <img
            :src="
              config.posterBtn && config.posterBtn.icon
                ? config.posterBtn.icon
                : require('../../assets/share/share_ico3.png')
            "
          />
          <div class="text">
            {{
              config.posterBtn && config.posterBtn.text
                ? config.posterBtn.text
                : '二维码'
            }}
          </div>
        </div>
      </template>

      <div class="opt" v-if="isShareCode" @click="shareCode">
        <img
          :src="
            config.copyBtn && config.copyBtn.icon
              ? config.copyBtn.icon
              : require('../../assets/share/share_ico5.png')
          "
        />
        <div class="text">
          {{
            config.copyBtn && config.copyBtn.text
              ? config.copyBtn.text
              : '分享口令'
          }}
        </div>
      </div>
      <div class="show_poster" :style="{ opacity: posterShowCondt ? 1 : 0 }">
        <Poster
          :qrCodeURL="config.qrcodeUrl"
          :posterImg="config.posterImg"
          :showType="2"
          v-if="posterShowCondt || shareWechatnPic"
          :qrCodeWidth="config.qrCodeWidth"
          :qrCodeTop="config.qrcodeTop"
          :qrCodeLeft="config.qrcodeLeft"
          ref="sharePoster"
        ></Poster>
      </div>
    </div>
    <!-- <div @click="show = false" class="cancel">取消</div> -->
  </bottomAlert>
</template>

<script>
import Poster from './poster';
import {
  callApp,
  isHllApp,
  isIOS,
  getUserAppVer,
  getUrlParam,
  isJdMiniProgram,
  isAlipayMiniUa,
  isWeixinBrowser,
  isAlipayH5,
  isWxMiniProgram,
  debounce
} from '@/utils';
import shareTip from '@f/shareTip';
import { isXlApp, isXlDriverApp, isXlUserNativeApp } from '@/utils/judgeEnv';
export default {
  name: 'shareAlert',
  /**
   * @param { object } config 分享配置
   * @param { number } isTimeout 点击分享回调延迟
   * @param { function } callback 点击分享回调
   * @param { boolean } isShowErr 是否弹出分享错误提示
   * @param { boolean } isShareCode 是否显示口令分享, config.codeStr: 口令
   * @param { boolean } isHideQrcode 是否隐藏二维码按钮
   * @param { boolean } sharePoster 是否显示海报分享, config.qrcodeUrl: 二维码图片 config.posterImg: 海报图片
   * @param { boolean } noShareWx 不显示微信分享: 默认：false,需要隐藏是为true
   * @param { boolean } shareTips 是否显示右上角分享提示
   * @param { boolean } shareWechatnPic 是否朋友圈直接分享海报
   * @param { boolean } sharePosterDireact 是否直接分享海报，常用于面对面分享
   */
  props: [
    'config',
    'isTimeout',
    'callback',
    'isShowErr',
    'shareWechatnPic',
    'sharePoster',
    'isShareCode',
    'isHideQrcode',
    'noShareWx',
    'shareTips',
    'sharePosterDireact'
  ],
  data() {
    return {
      show: false,
      viewType: 1,
      posterShow: false,
      posterURL: ''
    };
  },
  created() {
    this.$nextTick(() => {
      // if (isHllApp() && getUrlParam('revision') && !isIOS()) {
      //   this.share()
      // } else {
      this.viewType = process.env.VUE_APP_USE_VW == 3 && isIOS() ? 3 : 1;
      this.show = true;
      //}
    });
  },
  components: {
    Poster
  },
  computed: {
    isIOS() {
      return isIOS();
    },
    isHllApp() {
      return isHllApp();
    },
    isXL() {
      return getUrlParam('bl') === '8';
    },
    isXlApp() {
      return isXlApp();
    },
    isXlUserNativeApp() {
      return isXlUserNativeApp();
    },
    isXlDriverApp() {
      return isXlDriverApp();
    },
    isUserApp() {
      let portType = getUrlParam('portType');
      return (
        isHllApp() &&
        portType == 'hlluser' &&
        !/HLLPorterApp/.test(navigator.userAgent)
      );
    },
    posterShowCondt() {
      return (
        (this.posterShow && this.sharePoster) ||
        this.noShareWx ||
        this.sharePosterDireact
      );
    },
    isWxMiniProgram() {
      return isWxMiniProgram();
    },
    isAlipayMiniUa() {
      return isAlipayMiniUa() || isAlipayH5();
    },
    androindShare() {
      return this.isXlApp ? true : getUserAppVer() >= 6490 ? true : false;
    }
  },
  methods: {
    share: debounce(async function(to) {
      // console.log(this.config, '888888');
      let {
        miniprogram_path,
        miniprogram_webpage_url,
        miniprogram_id
      } = this.config;
      if (this.posterShowCondt && !this.posterURL) {
        await setTimeout(async () => {
          this.posterURL = await this.$refs.sharePoster.getBase64(0.4);
        }, 500);
      }
      /** 判断app端内海报分享条件 */
      let sharePicCondt =
        this.sharePoster &&
        to == 'wechatn' &&
        (this.posterShow || this.shareWechatnPic) &&
        isHllApp();
      /** 判断app可分享版本 */
      let appShareCondt = true;
      // let appShareCondt = isIOS() || (!isIOS() && this.androindShare);

      console.log(sharePicCondt, this.androindShare, 'sharePicCondt++++');
      let imgUrl = '';
      if (sharePicCondt && appShareCondt) {
        imgUrl = appShareCondt
          ? await this.$refs.sharePoster.getBase64(0.4)
          : this.config.posterImg;
        console.log(imgUrl, 'imgUrl++++');
      } else {
        if ((this.isUserApp || isWxMiniProgram()) && to != 'wechatn') {
          imgUrl = this.config.miniIco ? this.config.miniIco : this.config.img;
        } else {
          imgUrl = this.config.img;
        }
      }
      let miniprogramObj =
        miniprogram_path || miniprogram_webpage_url || miniprogram_id
          ? {
              miniprogram_path,
              miniprogram_webpage_url,
              miniprogram_id
            }
          : {};
      // 小拉用户app 和货运用户app 默认把对应的小程序分享给微信朋友
      // 小拉司机app 没有小程序  就分享到朋友圈就是海报
      let args = {
        action: 'shareDirect',
        type:
          sharePicCondt && appShareCondt
            ? 2
            : to == 'wechatn'
            ? 0
            : this.isUserApp || this.isXlUserNativeApp
            ? 1
            : 0, // 分享类型：0 普通链接、1 小程序、2 图片
        to: to, // 分享目标，多个目标用半角逗号分隔。目标枚举:wechat1-发送给微信朋友,wechatn-发送给微信朋友圈,qq1-发送给qq好友,qqn-发送给qq空间
        title: this.config.title, // 分享标题
        desc: this.config.desc, // 分享内容
        img: imgUrl, // 分享的图标url
        ...miniprogramObj,
        success: () => {
          console.log('分享成功');
        },
        error: () => {},
        link: this.config.link || location.href.split('#')[0] // 内容链接url
      };
      if (
        (isWxMiniProgram() ||
          isWeixinBrowser() ||
          isJdMiniProgram() ||
          this.isAlipayMiniUa) &&
        to !== 'save' &&
        this.shareTips &&
        this.shareTips.show &&
        this.shareTips.img
      ) {
        shareTip({
          imgUrl: this.shareTips.img,
          width: '320px',
          top: '23px',
          right: isWxMiniProgram() ? '153px' : '43px',
          duration: 5000
        });
      }
      if (typeof this.callback == 'function') {
        this.callback(to);
      }
      if (this.isTimeout) {
        this.$hll.showLoading(0);
        setTimeout(() => {
          this.$hll.hideLoading();
          this.shareAct(
            args,
            to,
            'shareDirect',
            this.isShowErr !== undefined ? this.isShowErr : true
          );
        }, this.isTimeout);
      } else {
        this.shareAct(
          args,
          to,
          'shareDirect',
          this.isShowErr !== undefined ? this.isShowErr : true
        );
      }
    }, 500),
    showPoster() {
      console.log('显示海报按钮点击');
      if (!this.posterURL) {
        setTimeout(async () => {
          this.posterURL = await this.$refs.sharePoster.getBase64(0.4);
          console.log(this.posterURL, 'this.posterURL');
        }, 200);
      }
      this.posterShow = true;
      if (typeof this.callback == 'function') {
        this.callback('posterShow');
      }
    },
    shareCode() {
      if (typeof this.callback == 'function') {
        this.callback('copy');
      }
      this.copy(this.config.codeStr);
    },
    copy(value) {
      let txa = document.createElement('textarea');
      txa.value = value;
      document.body.appendChild(txa);
      txa.select();
      let res = document.execCommand('copy');
      console.log(res, '复制回调');
      document.body.removeChild(txa);
    },
    saveImg: debounce(async function() {
      let isIosPLatform = isIOS();
      let imgKey = isIosPLatform
        ? 'content'
        : getUrlParam('revision') || this.isXlApp
        ? 'content'
        : 'data';
      if (isHllApp()) {
        this.$hll.showLoading({ disableLogo: this.isXL });
        window.savedCallback = () => {
          this.$hll.hideLoading();
          if (this.isXlApp) {
            if (!isIosPLatform) {
              this.$hll.toast('保存成功，已保存至手机相册');
            }
          } else {
            this.$hll.toast('保存成功，已保存至手机相册');
          }
        };
        this.posterURL = await this.$refs.sharePoster.getBase64(0.4);
        let test_val = this.posterURL.slice(0, 20);
        console.log(test_val, 'posterURL--->');
        // alert(test_val);
        callApp(
          JSON.stringify({
            action: 'saveImg',
            [imgKey]: this.posterURL,
            callback: 'savedCallback'
          })
        );
      } else {
        console.log('save  image ---->1');
        this.$hll.toast(
          (isAlipayH5() || isHllApp() || isWxMiniProgram()) && !isIosPLatform
            ? '请手机截图保存图片'
            : '长按可保存图片~'
        );
      }
      if (typeof this.callback == 'function') {
        this.callback('save');
      }
    }, 500),
    saveImg1() {
      console.log('save image --> click');
      setTimeout(async () => {
        let imgKey = isIOS()
          ? 'content'
          : getUrlParam('revision') || this.isXlApp
          ? 'content'
          : 'data';
        if (!this.posterURL) {
          console.log('存在this.posterURL---->');
          await setTimeout(async () => {
            this.posterURL = await this.$refs.sharePoster.getBase64(0.4);
            callApp(
              JSON.stringify({
                action: 'saveImg',
                [imgKey]: this.posterURL,
                callback: 'savedCallback'
              })
            );
          }, 500);
        } else {
          console.log('save  image ---->1');
          this.$hll.toast(
            (isAlipayH5() || isHllApp() || isWxMiniProgram()) && !isIOS()
              ? '请手机截图保存图片'
              : '长按可保存图片~'
          );
        }
        console.log(this.posterURL, 'posterURL--->');
        if (this.isHllApp || this.isXldriverApp) {
          console.log('save  image ---->2');
          window.savedCallback = () => {
            this.$hll.toast('保存成功，已保存至手机相册');
          };
          callApp(
            JSON.stringify({
              action: 'saveImg',
              [imgKey]: this.posterURL,
              callback: 'savedCallback'
            })
          );
        }
        if (typeof this.callback == 'function') {
          this.callback('save');
        }
      }, 10);
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/common/style.less';
.shareAlert {
  /deep/.as_bottom {
    padding-bottom: 0; //适配iPhoneX
    padding-bottom: constant(safe-area-inset-bottom); //适配iPhoneX
    padding-bottom: env(safe-area-inset-bottom); //适配iPhoneX
    bottom: 0px;
    height: 337px;
    background-color: rgba(250, 250, 250, 1);
    .as_content {
      overflow: inherit;
      .show_poster {
        position: absolute;
      }
    }
  }
  &.padBottom30 {
    /deep/.as_bottom {
      height: 377px;
    }
  }
  &.posterAlert {
    /deep/.as_bottom {
      background-color: transparent;
      padding-top: 0px;
      height: 1080px;
      .fcc;
      justify-content: flex-end;
      .as_title {
        display: none;
      }
      .as_content {
        height: 600px;
        background-color: #fff;
        .fcc;
        justify-content: flex-end;
        .optBox {
          margin-top: 100px;
        }
        .cancel {
          box-shadow: 0px -10px 10px rgba(0, 0, 0, 0.1);
        }
        .show_poster {
          position: absolute;
          left: 50%;
          transform: scale(0.68) translate(-375px, -1315px);
          box-shadow: 0px 12px 30px 0px rgba(46, 49, 56, 0.1);
        }
      }
    }
  }

  .optBox {
    width: 718px;
    margin-top: 20px;
    margin-bottom: 40px;
    position: relative;
    .fa;
    .opt {
      .fcc;
      font-size: 24px;
      font-weight: bold;
      color: rgba(163, 163, 163, 1);

      img {
        margin-bottom: 23px;
        width: 106px;
        height: 106px;
      }
    }
  }

  .cancel {
    margin-top: 50px;
    text-align: center;
    line-height: 98px;
    width: 718px;
    height: 98px;
    background: rgba(255, 255, 255, 1);
    font-size: 32px;
    font-weight: bold;
    color: rgba(163, 163, 163, 1);
  }
}
</style>
